/*
  18 Chestnuts, SOUPTOTE free tote auto-add. DRAFT, not installed.
  Purpose: Shopify discounts never add the free item to the cart.
  This storefront script closes that gap for one promo window.

  Pairing (required, do not change one without the other):
  - SOUPTOTE is an email only offer, so it stays a CODE. In Shopify
    admin: Buy X Get Y, discount code SOUPTOTE, Customer buys minimum
    purchase amount $100, Customer gets 1 tote Free, max uses per
    order 1, active Nov 4 to Nov 10, 2026, 11:59 pm ET, set to combine
    with shipping discounts.
  - The email CTA must be the Shopify shareable link for SOUPTOTE,
    which applies the code automatically to the next checkout, plus
    our own marker on the landing URL, for example the redirect page
    carrying ?free-tote=souptote. The script stores that marker in    sessionStorage and only then manages the gift line. Shoppers who
    never came through the email link never get a tote added, so a
    full price tote is never pushed into a cart that has no code.
  - Free shipping rides a separate AUTOMATIC free shipping discount,
    $100 minimum, same dates, combinable with product discounts.
    A shareable link can carry only one discount code.

  Config to fill at install:
  - TOTE_VARIANT_ID: variant id of the tote product once it is created.
  - EXCLUDED_VARIANT_IDS: gift card variants and any promo excluded    product that must not count toward the $100.  Behaviour:
  - Qualifying subtotal uses original line prices (full price, before
    discounts), mirroring how Buy X Get Y counts the minimum.  - The tote itself never counts toward its own threshold.
  - Only the gift line is managed. It carries the private property
    _free_gift. A tote a customer adds on purpose is a separate line
    with no such property and is never touched.
  - Gift line is capped at quantity 1 and removed if the cart drops
    below the threshold.
*/

(function () {
  'use strict';

  var CONFIG = {
    toteVariantId: 67954378309905, // 18 Chestnuts Canvas Tote Bag, product 15478242902289, set 2026-11-03
    excludedVariantIds: [], // TODO at install, gift cards etc.
    thresholdCents: 10000,
    // Promo window in epoch ms, store time Eastern.
    // Nov 4, 2026 12:00 am ET to Nov 10, 2026 11:59:59 pm ET.
    startsAtMs: 1793768400000,
    endsAtMs: 1794373199000,
    giftPropertyKey: '_free_gift',
    giftPropertyValue: 'Free tote on orders $100+',
    // Email only gate. Landing URL marker that arms the auto-add for
    // this browser session, set by the email link.
    activationParam: 'free-tote',
    activationValue: 'souptote',
    activationStorageKey: 'souptote-free-tote'
  };

  if (!CONFIG.toteVariantId) return;

  function isActivated() {
    try {
      var params = new URLSearchParams(window.location.search);
      if (params.get(CONFIG.activationParam) === CONFIG.activationValue) {
        window.sessionStorage.setItem(CONFIG.activationStorageKey, '1');
        return true;
      }
      return window.sessionStorage.getItem(CONFIG.activationStorageKey) === '1';
    } catch (e) {
      return false;
    }  }

  if (!isActivated()) return;

  var now = Date.now();
  if (now < CONFIG.startsAtMs || now > CONFIG.endsAtMs) return;

  var running = false;

  function cartUrl(path) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root + path;
  }

  function getCart() {
    return fetch(cartUrl('cart.js'), { credentials: 'same-origin' }).then(function (r) {
      return r.json();
    });
  }

  function addGift() {
    var body = {
      items: [
        {          id: CONFIG.toteVariantId,
          quantity: 1,
          properties: {}
        }
      ]
    };
    body.items[0].properties[CONFIG.giftPropertyKey] = CONFIG.giftPropertyValue;
    return fetch(cartUrl('cart/add.js'), {
      method: 'POST',
      credentials: 'same-origin',      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    });
  }

  function changeLine(lineKey, quantity) {
    return fetch(cartUrl('cart/change.js'), {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: lineKey, quantity: quantity })
    });
  }

  function refreshCartUi() {
    // Wired to this theme (Be Yours) at install: the cart drawer is
    // the <mini-cart> custom element (assets/cart-drawer.js). Its
    // renderContents method re-renders the mini-cart,
    // cart-icon-bubble and mobile-cart-icon-bubble sections from
    // section rendering data and then opens the drawer. Fetch fresh
    // section HTML for exactly those sections and hand it over.
    document.dispatchEvent(new CustomEvent('souptote:gift-changed'));
    var miniCart = document.querySelector('mini-cart');
    if (
      !miniCart ||
      typeof miniCart.renderContents !== 'function' ||
      typeof miniCart.getSectionsToRender !== 'function'
    ) {
      return;
    }
    var sectionNames = miniCart.getSectionsToRender().map(function (section) {
      return section.section;    });
    fetch(cartUrl('?sections=' + sectionNames.join(',')), {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    })
      .then(function (r) {
        return r.json();
      })
      .then(function (sectionsData) {
        miniCart.renderContents({ sections: sectionsData });
      })
      .catch(function () {
        /* drawer refresh hiccup, cart itself is already correct */
      });
  }  function qualifyingSubtotalCents(cart) {
    var total = 0;
    cart.items.forEach(function (item) {
      if (item.variant_id === CONFIG.toteVariantId) return;
      if (CONFIG.excludedVariantIds.indexOf(item.variant_id) !== -1) return;
      total += item.original_line_price;
    });    return total;
  }

  function findGiftLine(cart) {
    for (var i = 0; i < cart.items.length; i++) {
      var item = cart.items[i];
      if (
        item.variant_id === CONFIG.toteVariantId &&
        item.properties &&
        item.properties[CONFIG.giftPropertyKey]
      ) {
        return item;
      }
    }
    return null;  }

  function reconcile() {
    if (running) return;
    running = true;
    getCart()
      .then(function (cart) {
        var qualifies = qualifyingSubtotalCents(cart) >= CONFIG.thresholdCents;
        var gift = findGiftLine(cart);
        if (qualifies && !gift) {
          return addGift().then(function (resp) {
            // 422 or a short add means the tote is sold out.
            // Stay silent, do not retry in a loop.
            if (resp && resp.ok) refreshCartUi();
          });
        }
        if (qualifies && gift && gift.quantity > 1) {
          return changeLine(gift.key, 1).then(function () {
            refreshCartUi();
          });
        }
        if (!qualifies && gift) {
          return changeLine(gift.key, 0).then(function () {
            refreshCartUi();
          });
        }
      })      .catch(function () {
        /* cart API hiccup, next cart event retries */
      })
      .then(function () {
        running = false;
      });
  }

  var timer = null;  function schedule() {
    if (timer) clearTimeout(timer);
    timer = setTimeout(reconcile, 350);
  }

  document.addEventListener('DOMContentLoaded', schedule);
  document.addEventListener('cart:updated', schedule);
  document.addEventListener('ajaxCart.afterCartLoad', schedule);
  window.addEventListener('pageshow', schedule);

  var originalFetch = window.fetch;
  if (originalFetch) {
    window.fetch = function () {
      var result = originalFetch.apply(this, arguments);
      try {
        var url = arguments[0] && arguments[0].toString();
        if (url && (url.indexOf('cart/add.js') !== -1 || url.indexOf('cart/change.js') !== -1 || url.indexOf('cart/update.js') !== -1)) {
          result.then(schedule).catch(function () {});
        }
      } catch (e) {}
      return result;
    };
  }
})();
